module.exports = __webpack_public_path__ + "d0a9fdcf35252fbdab499dba5539f4f1.jpg";